/*
 * Handler called when the checkbox is clicked and changes the state
 */
function LmsCheckbox_ChangeState(label) {

    var checkbox = label.prev();
    if (checkbox[0].checked === true) {
        checkbox.attr('checked', false);
        checkbox[0].checked = false;
    } else {
        checkbox.attr('checked', true);
        checkbox[0].checked = true;
    }

    var targetMode = label.attr('data-targetmode');
    var hasButtonTarget = label[0].hasAttribute('data-targetbutton');
    var hasMessageTarget = label[0].hasAttribute('data-targetmessage');

   
    if (!hasButtonTarget && !hasMessageTarget) {
        return;
    }

    if (hasButtonTarget) {
        var targetButtonId = label.attr('data-targetbutton');
        var targetButton = $('#' + targetButtonId);
        // work around for eyeable night mode - changes targetbutton id ;-(
        if (!targetButton.length) {
            targetButton = $('#' + targetButtonId.replaceAll('_', ''));
        }

        if (targetMode === 'EnableOnChange') {
            targetButton.removeClass('disabled');
            targetButton.removeAttr('disabled');
        } else if (targetMode === 'ToggleOnChange') {
            if (targetButton.hasClass('disabled') === true) {
                targetButton.removeClass('disabled');
                targetButton.removeAttr('disabled');
            } else {
                targetButton.addClass('disabled');
                targetButton.attr('disabled', 'disabled');
            }
        } else if (targetMode === 'SameState') {
            if (checkbox[0].checked === true) {
                targetButton.removeClass('disabled');
                targetButton.removeAttr('disabled');
            } else {
                targetButton.addClass('disabled');
                targetButton.attr('disabled', 'disabled');
            }
        }
    }

    if (hasMessageTarget) {
        var targetMessage = $('#' + label.attr('data-targetmessage'));
        if (targetMode === 'EnableOnChange') {
            targetMessage.css('display', '');
        } else if (targetMode === 'ToggleOnChange') {
            if (targetMessage.css('display') === 'none') {
                targetMessage.css('display', '');
            } else {
                targetMessage.css('display', 'none');
            }
        } else if (targetMode === 'SameState') {
            if (checkbox[0].checked === true) {
                targetMessage.css('display', '');
            } else {
                targetMessage.css('display', 'none');
            }
        }
    }
}